import { FC, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Image } from '@chakra-ui/react';
import Text from '@molecules/Text';

import fallbackPicture from '@view/assets/images/fallback-picture.png';
import AccommodationGalleryProps from './AccommodationGalleryProps';

const StyledAccommodationGallery = styled.div`
    --height: 340px;

    @media screen and (max-width:1280px) {
        --height: 340px;
    }

    position: relative;
    width: 100%;
    height: var(--height);
    border-radius: 16px;
    overflow: hidden;

    .image-grid {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(2, calc(var(--height) / 2 - 8px / 2));
        gap: 8px;
    }

    .image-content {
        position: relative;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .see-more {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        pointer-events: none;
    }

    .image-content > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        user-select: none;
        -webkit-user-drag: none;
    }

    .image-grid > .image-content:first-of-type {
        grid-column: span 2;
        grid-row: span 2;
    }
`;

const AccommodationGallery: FC<AccommodationGalleryProps> = (
  props: AccommodationGalleryProps
) => {
  const [images, setImages] = useState<string[]>([]);
  const [totalImages, setTotalImages] = useState<number>(props.images.length);

  useEffect(() => {
    setTotalImages(props.images.length);
    const list: string[] = [];
    for (let i = 0; i < 5; i++) {
      list.push(props.images.length > i ? props.images[i].thumb : '');
    }

    setImages(list);
  }, [props.images]);

  function onClickImage(index = 0) {
    props.onClickItem?.(index);
  }

  return (
    <StyledAccommodationGallery>
      <div className="image-grid">
        {images.map((img, index) => (
          <Box
            key={index}
            className="image-content"
            onClick={() => onClickImage(index)}
          >
            <Image alt="" src={img} fallbackSrc={fallbackPicture} />
            {index === 4 && totalImages > images.length && (
              <Box className="see-more">
                <Text color="white">
                  + {totalImages - images.length + 1} photos
                </Text>
              </Box>
            )}
          </Box>
        ))}
      </div>
    </StyledAccommodationGallery>
  );
};

export default AccommodationGallery;
